// extracted by mini-css-extract-plugin
module.exports = {"container":"NewOrderDetails_container__3GbEH","buttonsWrapper":"NewOrderDetails_buttonsWrapper__CqQD5"};